// Training phases (Bigger Leaner Stronger p.314-315, 332-333): 9 weeks each,
// 8 hard weeks then a deload week. About six phases a year. Pure.
//
// The deload week repeats the last week's workouts with 2 hard sets per exercise
// instead of 3, at normal working weights, but only 2 reps a set on big lifts and
// 4 on accessory lifts, plus easy cardio only.

export const PHASE_WEEKS = 9;
export const DELOAD_SETS = 2;
export const DELOAD_REPS_PRIMARY = 2;
export const DELOAD_REPS_ACCESSORY = 4;

// Monday of the week that contains dateISO (local calendar dates, YYYY-MM-DD).
export function mondayOf(dateISO) {
  const [y, m, d] = dateISO.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  const dow = dt.getUTCDay();
  dt.setUTCDate(dt.getUTCDate() - (dow === 0 ? 6 : dow - 1));
  return dt.toISOString().slice(0, 10);
}

// { phase, week, deload, started } for a phase that began the week of phaseStartISO.
// No start yet -> null (it starts with the first logged workout).
export function phaseInfo(phaseStartISO, todayISO) {
  if (!phaseStartISO || !todayISO) return null;
  const start = mondayOf(phaseStartISO);
  const [sy, sm, sd] = start.split('-').map(Number);
  const [ty, tm, td] = todayISO.split('-').map(Number);
  const days = Math.round((Date.UTC(ty, tm - 1, td) - Date.UTC(sy, sm - 1, sd)) / 86400000);
  if (days < 0) return { phase: 1, week: 1, deload: false, started: start };
  const weeks = Math.floor(days / 7);
  const phase = Math.floor(weeks / PHASE_WEEKS) + 1;
  const week = (weeks % PHASE_WEEKS) + 1;
  return { phase, week, deload: week === PHASE_WEEKS, started: start };
}

export function phaseLabel(info) {
  if (!info) return '';
  return info.deload ? `Phase ${info.phase} · Deload week` : `Phase ${info.phase} · Week ${info.week} of ${PHASE_WEEKS - 1}`;
}

// Local calendar date as YYYY-MM-DD (not UTC, so a late-evening workout stays on today).
export function localISO(d = new Date()) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
